module.exports = __webpack_public_path__ + "static/media/delete_btn.394053de.svg";